<script setup lang="ts">
import {breakpointsTailwind, useBreakpoints} from '@vueuse/core'
import {ref} from 'vue'

const props = defineProps<{ height?: number, upload?: boolean }>()
const breakpoints = useBreakpoints(breakpointsTailwind)
const smallerThanLg = breakpoints.smaller('md')
const emit = defineEmits(['closed', 'opened'])
const openState = ref<boolean>(false)
const closingState = ref<boolean>(false)
const alertOpen = ref<boolean>(false)

const toggleOpen = (isPublish = false) => {
  if (openState.value) {
    // if (props.upload && !isPublish) {
    //   alertOpen.value = true
    // } else {
    //   confirmClose()
    // }
    confirmClose()
  } else {
    openState.value = true
    emit('opened')
    document.body.classList.add('no-scroll')
  }
}

const confirmClose = () => {
  closingState.value = true
  setTimeout(() => {
    openState.value = false
    closingState.value = false
    document.body.classList.remove('no-scroll')
  }, 200)
  emit('closed')
  alertOpen.value = false
}

const cancelClose = () => {
  alertOpen.value = false
}

defineExpose({toggleOpen});
</script>


<template>
  <slot name="trigger" :open="toggleOpen" :close="toggleOpen"></slot>
  <Dialog :open="openState && !smallerThanLg" @update:open="toggleOpen">
    <slot name="dialog-content" :open="toggleOpen" :close="toggleOpen"></slot>
  </Dialog>
  <teleport to="body">
    <div v-if="(openState || closingState) && smallerThanLg">
      <div class="overlay" @click="toggleOpen"></div>
      <div class="static-modal flex flex-col border-t-[0.5px] border-gray-50"
           :class="{ animated: openState, 'slide-out': closingState }"
           :style="{ height: (props.height ?? 100) + 'svh' }">
        <slot name="static-drawer-content"></slot>
      </div>
    </div>
  </teleport>
  <AlertDialog v-model:open="alertOpen">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogDescription class="font-bold text-lg text-foreground  mb-2">
          Odrzucić wątek?
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter class=" grid grid-cols-2 gap-2 place-items-center">
        <AlertDialogCancel class="m-0 h-10 bg-popover  focus-visible:ring-0 focus:ring-0" @click="cancelClose">Anuluj
        </AlertDialogCancel>
        <AlertDialogAction class="m-0 h-10 bg-popover text-red font-bold border-gray-50 border"
                           @click="confirmClose">
          Odrzuć
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>

<style>
.overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 69;
}

.static-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background: var(--popover);
  display: flex;
  z-index: 70;
  padding-bottom: env(safe-area-inset-bottom);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow: hidden;
}

.animated {
  animation: slideIn 0.3s forwards;
}

.slide-out {
  animation: slideOut 0.3s forwards;
}

@keyframes slideIn {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slideOut {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}
</style>
